module.exports = '<svg width="64" height="32" viewBox="0 0 64 32"><path d="M64 8.24v16c0 4.396-3.6 7.76-8 7.76H40c-2.2 0-4-1.8-4-4s1.8-4 4-4h12c2.2 0 4-1.564 4-3.76v-8C56 10.04 54.2 8 52 8h-9.84l-2.68 4H44c2.2 0 4 1.8 4 4s-1.8 4-4 4h-9.84l-6.84 10.32-.04-.1C26.56 31.296 25.4 32 24 32H8c-4.44 0-8-3.364-8-7.76v-16C0 3.84 3.6 0 8 0h16c2.2 0 4 1.8 4 4s-1.8 4-4 4H12c-2.2 0-4 2.04-4 4.24v8C8 22.436 9.8 24 12 24h9.84l2.68-4H20c-2.2 0-4-1.8-4-4s1.8-4 4-4h9.84l6.84-10.08.04-.024C37.44.82 38.6 0 40 0h16c4.4 0 8 3.796 8 8.24z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/link-1.js
// module id = 1233
// module chunks = 14